<template>
  <div v-if="show" class="modal-backdrop">
    <div class="modal-content">
      <div>
        <div class="modal-close">
          <ClearIcon />
        </div>
      </div>
      <h2 class="modal-title">
        {{ t('component.ga.manage_consent.title') }}
      </h2>
      <p class="modal-description">
        {{ t('component.ga.manage_consent.description') }}
      </p>
      <div class="consent-options">
        <label>
          <input
            type="radio"
            :value="CONSENT_STATUS_ENUM.ACCEPTED"
            :checked="consentStatus === CONSENT_STATUS_ENUM.ACCEPTED"
            @change="setConsentStatus(CONSENT_STATUS_ENUM.ACCEPTED)"
          />
          {{ t('component.ga.manage_consent.accept') }}
        </label>
        <label>
          <input
            type="radio"
            :value="CONSENT_STATUS_ENUM.REJECTED"
            :checked="consentStatus === CONSENT_STATUS_ENUM.REJECTED"
            @change="setConsentStatus(CONSENT_STATUS_ENUM.REJECTED)"
          />
          {{ t('component.ga.manage_consent.decline') }}
        </label>
      </div>
      <div class="modal-buttons">
        <button class="modal-button save" @click="saveConsent">
          {{ t('component.ga.manage_consent.save') }}
        </button>
        <button class="cancel modal-button" @click="closeModal">
          {{ t('component.ga.manage_consent.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ConsentStatus, CONSENT_STATUS_ENUM } from '@/common/gaHelper';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const analyticsConsentModule = namespace('analyticsConsent');

@Component
export default class ManageConsentGAModal extends Vue {
  @Prop({ default: true }) show!: boolean;

  @analyticsConsentModule.State('consentStatus') consentStatus!: ConsentStatus;
  @analyticsConsentModule.Mutation('setConsentStatus') setConsentStatus!: (consent: ConsentStatus) => void;

  readonly CONSENT_STATUS_ENUM = CONSENT_STATUS_ENUM;

  closeModal() {
    this.$emit('close');
  }

  saveConsent() {
    if (this.consentStatus === this.CONSENT_STATUS_ENUM.ACCEPTED) {
      this.$gtag.optIn();
    } else {
      this.$gtag.optOut();
    }
    this.closeModal();
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/base.scss';

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  display: flex;
  flex-direction: column;
  justify-content: center;

  position: relative;
  background-color: $ga-manage-consent-background;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 100%;
  height: 100%;
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.modal-title {
  font-size: $size-m2;
  color: #333;
  margin-bottom: 10px;
}

.modal-description {
  font-size: $size-xs;
  color: #666;
  margin-bottom: 20px;
}

.consent-options {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
}

.consent-options label {
  font-size: $size-xs;
  color: #333;
  margin-bottom: 10px;
}

.consent-options input[type='radio'] {
  margin-right: 10px;
}

.modal-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.modal-button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: $size-xs;
  cursor: pointer;
}

.save {
  background-color: $ga-manage-consent-save-button-background-color;
  color: $ga-manage-consent-save-button-text-color;
}

.cancel {
  background-color: $ga-manage-consent-cancel-button-background-color;
  color: $ga-manage-consent-cancel-button-text-color;
  border: 1px solid $ga-manage-consent-cancel-button-text-color;
}
</style>
